import { combineReducers } from 'redux';
import Immutable from 'seamless-immutable';

import * as actionTypes from './action-types';

function byPrettyId(state = Immutable({}), action) {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY_TEAM_MEMBER_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.START:
      return state.merge(
        {
          [action.payload.prettyId]: {
            fetchingCompanyTeamMemberConnectionsForAdmin: true,
          },
        },
        { deep: true }
      );
    case actionTypes.FETCH_COMPANY_TEAM_MEMBER_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.SUCCESS:
      return state.merge(
        {
          [action.payload.prettyId]: {
            fetchingCompanyTeamMemberConnectionsForAdmin: false,
            lastFetchedCompanyTeamMemberConnectionsForAdminAt: new Date().toISOString(),
          },
        },
        { deep: true }
      );
    case actionTypes.FETCH_COMPANY_TEAM_MEMBER_CONNECTIONS_FOR_ADMIN_BY_PRETTY_ID.FAILURE:
      return state.merge(
        {
          [action.payload.prettyId]: {
            fetchingCompanyTeamMemberConnectionsForAdmin: false,
          },
        },
        { deep: true }
      );
    default:
      return state;
  }
}

export default combineReducers({
  byPrettyId,
});



// WEBPACK FOOTER //
// ./src/store/features/admin/companies/team-members/reducer.js